import React, { useCallback, useMemo } from 'react';
import Modal from 'react-modal';
import iClose from '../../assets/close.svg';

export const MobileModal = (props: {
  setIsShow: Function;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  title?: string;
  width?: number;
  appElement?: HTMLElement;
  modalIsOpen?: boolean;
  notClose?: boolean;
  zIndex?: number;
  diyStyle?: React.CSSProperties;
  opacity?: number;
  fullScreen?: boolean;
  fixedHeader?: boolean;
}) => {
  const {
    setIsShow,
    children,
    width,
    modalIsOpen,
    zIndex,
    diyStyle = {},
    opacity,
    className,
    overlayClassName,
    fullScreen,
    fixedHeader,
  } = props;
  if (props.fullScreen) {
    Object.assign(diyStyle, {
      maxHeight: '',
      maxWidth: '',
      position: 'absolute',
      left: 10,
      right: 10,
      bottom: 10,
      top: 10,
    });
  }
  const _diyStyle = useMemo(() => {
    if (fullScreen) {
      return {
        ...diyStyle,
        maxHeight: '',
        maxWidth: '',
        position: 'absolute',
        left: 10,
        right: 10,
        bottom: 10,
        top: 10,
      };
    }
    return diyStyle;
  }, [diyStyle, fullScreen]);

  const contentStyle = useMemo(
    () => ({
      position: 'static',
      maxHeight: '90vh',
      maxWidth: '90vw',
      border: '1px solid var(--search-select)',
      background: 'var(--bg-white-color)',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      borderRadius: '6px',
      boxShadow: '0 3px 8px 0 rgba(var(--color-black-rgba),0.05)',
      outline: 'none',
      padding: '30px 24px',
      boxSizing: 'border-box',
      width,
      ..._diyStyle,
    }),
    [_diyStyle, width],
  );

  const titleStyle = useMemo(() => {
    const style = fixedHeader
      ? {
          position: 'sticky',
          top: -50,
          color: 'var(--color-title)',
          background: 'var(--bg-white-color)',
          zIndex: 10,
          paddingTop: 50,
          marginTop: -50,
        }
      : {};
    return {
      fontSize: 20,
      fontWeight: 'bold',
      paddingBottom: 30,
      display: 'flex',
      justifyContent: 'space-between',
      color: 'var(--color-title)',
      ...style,
    };
  }, [fixedHeader]);

  const handleClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  return (
    <div onClick={handleClick}>
      <Modal
        ariaHideApp={false}
        onRequestClose={() => {
          setIsShow(false);
        }}
        shouldReturnFocusAfterClose={false}
        appElement={props.appElement}
        isOpen={modalIsOpen ?? true}
        className={className}
        overlayClassName={overlayClassName}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: `rgba(var(--color-black-rgba), ${opacity || 0.4})`,
            zIndex: zIndex || 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          /* @ts-ignore */
          content: contentStyle,
        }}
        contentLabel="Example Modal">
        {props.title && (
          <div
            /* @ts-ignore */
            style={titleStyle}>
            {props.title}
            {!props.notClose && (
              <img
                onClick={() => props.setIsShow(false)}
                style={{
                  cursor: 'pointer',
                  marginTop: 2,
                  float: 'right',
                  opacity: 0.6,
                  marginLeft: 12,
                }}
                alt=""
                width={20}
                height={20}
                src={iClose}
              />
            )}
          </div>
        )}
        {children}
      </Modal>
    </div>
  );
};

export default MobileModal;
